import React from 'react';
import { Tree, Card } from 'antd';
import { connect } from 'dva';
import styles from './Index.less';

@connect(({ AddressBook, loading }) => ({
  chargeTarget: AddressBook.chargeTarget,
  contentLoading: loading.effects['AddressBook/fetchDepartTree'],
}))
export default class StructureTree extends React.Component {
  constructor(props) {
    super(props);

    this.onLoadData = this.onLoadData.bind(this);
    this.renderTreeNodes = this.renderTreeNodes.bind(this);
    this.handleCheckedNodes = this.handleCheckedNodes.bind(this);
  }

  componentWillMount() {
    const { entitySigns } = this.props;

    // 每次组件加载都重新获取机构树数据
    this.props.dispatch({
      type: 'AddressBook/fetchDepartTree',
      entitySigns,
    });
  }

  // 非叶子节点的数据加载
  onLoadData(treeNode) {
    return new Promise(resolve => {
      // 每次展开节点，无论是叶节点还是子节点，都获取人员信息
      this.props
        .dispatch({
          type: 'AddressBook/fetchDepartUser',
          orgStructId: treeNode.props.dataRef.deptId,
          managementEntitySign: treeNode.props.dataRef.deptType,
        })
        .then(() => {
          resolve();
        });
    });
  }

  // 选中/取消选中某节点
  handleCheckedNodes(checkedKeys, e) {
    const { checked } = e;
    const { dataRef } = e.node.props;

    if (checked) {
      this.props.dispatch({
        type: 'AddressBook/setSelectedUser',
        payload: {
          option: 'add',
          node: {
            id: dataRef.deptId,
            name: dataRef.deptName,
            type: dataRef.deptType,
            parentId: dataRef._parentId,
            isLeaf: dataRef.isLeaf,
            groupType: dataRef.groupType,
          },
        },
      });
    } else {
      this.props.dispatch({
        type: 'AddressBook/setSelectedUser',
        payload: {
          option: 'delete',
          node: {
            id: dataRef.deptId,
            name: dataRef.deptName,
            parentId: dataRef._parentId,
          },
        },
      });
    }
    // 更新树组件默认选中的key集合
    setTimeout(() => {
      this.props.dispatch({
        type: 'AddressBook/setCheckedKeyList',
        payload: { keyList: checkedKeys },
      });
    }, 0);
  }

  // 渲染树节点，对于非叶子节点会递归调用该方法
  renderTreeNodes(data) {
    const { TreeNode } = Tree;

    return data.map(item => {
      if (item.subDepts) {
        return (
          <TreeNode
            selectable={false}
            title={item.deptName}
            key={item.deptId}
            dataRef={item}
            isLeaf={false}
          >
            {this.renderTreeNodes(item.subDepts)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          selectable={false}
          title={item.deptName}
          key={item.deptId}
          dataRef={item}
          isLeaf={!!item.isLeaf}
        />
      );
    });
  }

  render() {
    const { contentLoading } = this.props;
    const { defaultCheckedKey, addressBook } = this.props.chargeTarget;

    return (
      <Card bordered={false} loading={contentLoading}>
        <Tree
          checkable
          checkedKeys={defaultCheckedKey}
          loadData={this.onLoadData}
          onCheck={this.handleCheckedNodes}
          className={styles['tree-container']}
        >
          {this.renderTreeNodes(addressBook)}
        </Tree>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/Address/StructureTree/Index.js